import React, { FC, useCallback, useState } from 'react';
import classnames from 'classnames';

import {
    useCurrentUserActionIndicator,
    useUserActionIndicatorChangers,
} from '../../../../hooks/skin/use-user-action-indicator';
import { SEEK_INTERVAL } from '../../../../constants/skin';

import styles from './styles.module.css';

interface Props {
    className?: string;
}

export const UserActionIndicatorView: FC<Props> = ({ className }) => {
    const currentIndicator = useCurrentUserActionIndicator();
    const { clearIndicator } = useUserActionIndicatorChangers();

    const [key, setKey] = useState(0);

    const handleAnimationEnd = useCallback(() => {
        clearIndicator();
        setKey((prev) => prev + 1);
    }, [clearIndicator]);

    if (!currentIndicator) {
        return null;
    }

    const isSeek = currentIndicator === 'seekBackward' || currentIndicator === 'seekForward';

    return (
        <div className={classnames(styles.root, className)} dir="ltr" key={key}>
            <div
                className={classnames(styles.indicator, {
                    [styles.play]: currentIndicator === 'play',
                    [styles.pause]: currentIndicator === 'pause',
                    [styles.seekForward]: currentIndicator === 'seekForward',
                    [styles.seekBackward]: currentIndicator === 'seekBackward',
                })}
                onAnimationEnd={handleAnimationEnd}
            >
                {isSeek && <div className={styles.seekInterval}>{SEEK_INTERVAL}</div>}
            </div>
        </div>
    );
};
